import type { ISubsidiary } from '../../types';
import { getSubsidiaryUrl } from '../../constants/subsidiaryLinks';

interface HoldingsSectionProps {
  subsidiaries?: ISubsidiary[];
  isLoading: boolean;
}

const subsidiaryLogos: Record<string, string> = {
  'DeFi Assets LLC':             '/subsidiaries_logos/Defi Assets LLC Logo.png',
  'Vivasvat': '/subsidiaries_logos/vivasvatrevolutionslogo-white.png',
  'AI Adya LLC':                 '/subsidiaries_logos/aiadya logo.png',
};

function getSubsidiaryLogo(name: string): string | null {
  for (const [key, path] of Object.entries(subsidiaryLogos)) {
    if (name.toLowerCase().includes(key.toLowerCase())) return path;
  }
  return null;
}

function getFlag(jurisdiction: string) {
  if (!jurisdiction) return 'Subsidiary';
  if (jurisdiction.toLowerCase().includes('india')) return 'India Subsidiary';
  return 'US Subsidiary';
}

function getInitials(name: string) {
  return name.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase();
}

export default function HoldingsSection({ subsidiaries, isLoading }: HoldingsSectionProps) {
  const items = subsidiaries ?? [];

  return (
    <section id="subsidiaries" className="holdings-section">
      <div className="holdings-intro">
        <div className="eyebrow-label">Our Subsidiaries</div>
        <h2>Three Companies, <span style={{ color: 'var(--gold)', fontStyle: 'italic' }}>One Strategic Vision</span></h2>
        <p className="lead">
          Each subsidiary operates with distinct focus, jurisdiction, and mandate — together forming the infrastructure backbone of Apex DeFi Labs Inc.
        </p>
      </div>

      <div className="sub-grid">
        {isLoading
          ? Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="sub-card" style={{ minHeight: 280 }} />
            ))
          : items.map((sub) => {
              const url = getSubsidiaryUrl(sub.name);
              const card = (
                <>
                  <div className="sub-flag">{getFlag(sub.jurisdiction)}</div>
                  <div className="sub-icon">
                    {getSubsidiaryLogo(sub.name)
                      ? <img src={getSubsidiaryLogo(sub.name)!} alt={sub.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                      : getInitials(sub.name)}
                  </div>
                  <div className="sub-name">{sub.name}</div>
                  <div className="sub-role">{sub.type}</div>
                  <div className="sub-text">{sub.description}</div>
                  {url && <span className="sub-link">Visit Website →</span>}
                </>
              );

              if (url) {
                return (
                  <a key={sub._id} href={url} target="_blank" rel="noopener noreferrer" className="sub-card">
                    {card}
                  </a>
                );
              }
              return <div key={sub._id} className="sub-card">{card}</div>;
            })}
      </div>
    </section>
  );
}
